import React from 'react';
import CacheBuster from 'react-cache-buster';
// import { useDispatch, useSelector } from "react-redux";
import { version } from '../package.json';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
// import { IsUserRedirect } from './helpers/routes';
// import { useAuthListener } from './hooks';
import './scss/style.scss';
import './assets/icons/font-awesome';
// import { AUTH_RESET, ON_CHECK_TOKEN, ON_PROCEED_RESET } from './store/action-types';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
// const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
// const Login = React.lazy(() => import('./views/pages/login/Login'));
// const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
// const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));
const Main = React.lazy(() => import('./views/Main/Main'));

const App = () => {
    // const dispatch = useDispatch();
    // const isProduction = process.env.NODE_ENV === 'production';
    // const { user } = useAuthListener();
    // const { isTokenExpired } = useSelector((state) => state.appReducer);
    

    // useEffect(() => {
    //     if (localStorage.getItem("access_token") !== null) {
    //         dispatch({ type: ON_CHECK_TOKEN });
    //     }
    // }, [dispatch])

    // useEffect(() => {
    //     if(isTokenExpired) {
    //         localStorage.removeItem('access_token');
    //         console.log('Token Expired');
    //         dispatch({ type: AUTH_RESET });
    //         dispatch({ type: ON_PROCEED_RESET });
    //         window.location = '/login';
    //     }
    // }, [isTokenExpired])
    
    return (
        <CacheBuster
            currentVersion={version}
            // isEnabled={isProduction} //If false, the library is disabled.
            isEnabled={true} //If false, the library is disabled.
            isVerboseMode={false} //If true, the library writes verbose logs to console.
        >
            <BrowserRouter basename='/promotional-terms-and-conditions'>
                <React.Suspense fallback={loading}>
                    <Switch>
                        {/* <Route exact path="/update-my-details" name="Page 500" render={props => <UpdateDetails {...props}/>} /> */}

                        {/* <IsUserRedirect exact name="Login Page" user={user} loggedInPath='/' path="/login">
                            <Login/>
                        </IsUserRedirect>
                        
                        <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
                        <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} /> */}
                        
                        <Route path="/" name="Home" render={props => <Main {...props}/>} />
                    </Switch>
                </React.Suspense>
            </BrowserRouter>
        </CacheBuster>
    );
}

export default App;
